/* eslint-disable */
export default {
  add: 'Hinzufügen',
  noCalls: 'Keine verfügbaren Anrufe',
  activeCall: 'Aktiver Anruf',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
